import { Link, makeStyles } from "@fluentui/react-components"
import * as React from "react"
import { FormattedMessage } from "react-intl"

import { makeDocsLink } from "@tdp/common/constants"
import { DetailsPage } from "@tdp/common/detailsPage"

import AppFeaturesCards from "./AppFeaturesCards"

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
  }
});

export const AppFeaturesPage: React.FC = () => {
  const styles = useStyles();

  return (
    <DetailsPage
      heading={
        <FormattedMessage
          defaultMessage={"App features"}
          description={"Heading for app features page"} />
      }
      description={
        <FormattedMessage
          defaultMessage={"These are the Teams features you can include in your app. Add one or more features depending on your app's use cases.<a_learnMore>Learn more about app features.</a_learnMore>"}
          description={"Description for app features page"} 
          values={{
            a_learnMore: (chunks: React.ReactNode) => (
              <Link
                href={makeDocsLink("microsoftteams/platform/concepts/capabilities-overview")}
                target="_blank"
              >
                {chunks}
              </Link>
            ),
          }}
          />
      }
    >
      <div className={styles.container}>
        <AppFeaturesCards isAdded />
        <AppFeaturesCards />
      </div>
    </DetailsPage>
  )
}
